export default "__VITE_ASSET__RAwhZLPv__"